import { Button, Modal } from "react-bootstrap";
import ComunidadCrearEquipo from "../comunidad/comunidadCrearEquipo";
import Loading from "../loading/Loading";
import { useEffect, useState } from "react";
import { getComunidad, setOrgToken } from "../../controllers/org";
import { getMembers } from "../../controllers/user";
import { useAuth } from "../auth/AuthProvider";

function TeamCreationModal({ show, handleClose, comunidadId, etapaId, onSuccess, user }) {
  const [members, setMembers] = useState();
  const { token } = useAuth();
  setOrgToken(token);

  useEffect(() => {
      if (!members) {
        loadMembers();
      }
    }, []);

  async function loadMembers() {
    try {
      let r = await getMembers(token, {
        comunidad: comunidadId,
        etapa: etapaId
      });
      console.log(r.rows.length);
      console.log(r.rows.filter(m => !m.team_member && m.etapa_id === etapaId).length);
      setMembers(r.rows.filter(m => !m.team_member && m.etapa_id === etapaId));
    }
    catch (e) {
      console.log(e);
      if (!isNaN(e.status)) {
        // setErrorCode(e.status);
      }
    }
  }

  if (!members) {
    return <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Crear Equipo</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Loading />
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Cerrar
        </Button>
      </Modal.Footer>
    </Modal>;
  }

  return <Modal show={show} onHide={handleClose}>
    <Modal.Header closeButton>
      <Modal.Title>Crear Equipo</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <ComunidadCrearEquipo
        comunidadId={comunidadId} 
        miembros={members} 
        ciclo={2025} 
        equipos={[]} 
        onSuccess={onSuccess}
        etapaId={etapaId}
        coordinadorId={user.membership.membership_id}
      />
      {/* <ComunidadCrearEquipo /> */}
    </Modal.Body>
    <Modal.Footer>
      <Button variant="secondary" onClick={handleClose}>
        Cerrar
      </Button>
    </Modal.Footer>
  </Modal>;
}

export default TeamCreationModal;
